import styled from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${ms(platform.isWeb ? 20 : 15)};
`;

export const SelectAllContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: ${ms(16)};
  padding-block-end: ${ms(10)};
  border-bottom: 1px solid ${getColor('border1')};
`;

export const SelectAllLabel = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${ms(16)};
  line-height: ${ms(20)};
`;
